import { observable, action, computed } from 'mobx';
import { ReqInputMsg, Addition, callCmd } from 'lib/reqInputMsg';
import { notification } from 'antd';

export default class CompanyStore {
  constructor(root) {
    this.root = root;
  }

  //----------------------------------
  /* Mainstore에서 세션만료 처리하기위해 */
  @observable
  _commonStoreInfo = null;

  @computed
  get commonStoreInfo() {
    return this._commonStoreInfo;
  }

  @action
  setCommonStoreInfo = (storeInfo) => {
    this._commonStoreInfo = storeInfo;
  };
  
  @observable
  _companyMain = [];

  @computed
  get companyMain() {
    return this._companyMain;
  }

  @observable
  _companyList = [];

  @computed
  get companyList() {
    return this._companyList;
  }

  @action
  onClear = () => {
    this._companyMain = [];
    this._companyList = [];

    this._dashboardInfo = null;
  };

  //----------------------------------
  @action
  disCompanyList = async (cpType, useYn) => {
    let addition = new Addition();
    addition.setCmdName('DIS-COMPANY-LIST');
    
    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);

    reqInputMsg.addParam({paraName: 'cpType', paraValue: cpType});
    if (useYn !== undefined && useYn !== null) {
      reqInputMsg.addParam({paraName: 'useYn', paraValue: useYn});
    }

    return await callCmd(reqInputMsg, 'rest')
      .then((res) => {
        if (res.error.code === '0000') {
          // notification.success({placement: 'bottomLeft', message:`조회가 성공하였습니다.`, duration: 2});
          if (cpType === 'M') {
            this._companyMain = res.result;
          } else {
            this._companyList = res.result;
          }
          
        } else if (res.error.code === '0003') {
          if (this._commonStoreInfo !== null) {
            this._commonStoreInfo.onSessionOut();
          }
        } else {
          notification.error({placement: 'bottomLeft', message:`리스트를 불러오는데 실패하였습니다.`, duration: 2, description: `${res.error.code}`});
          if (cpType === 'M') {
            this._companyMain = [];
          } else {
            this._companyList = [];
          }
        }
      }).catch((error) => {
        notification.error({placement: 'bottomLeft', message:`조회가 실패하였습니다.`, duration: 2, description: `서버 연결을 확인하세요.`});
        if (cpType === 'M') {
          this._companyMain = [];
        } else {
          this._companyList = [];
        }
        console.log('error', error);
      });
  };

  @action
  saveCompanyList = async (cpType, dataList) => {
    if (dataList !== undefined && dataList !== null) {
      const newData = [...dataList];
      let vArr = [];
      newData.map((item,idx)=>{
        return(vArr.push({...item, cpType: cpType, cpTabOrder: idx}))
      });
      dataList = vArr;
    }
    
    let addition = new Addition();
    addition.setCmdName('SAVE-COMPANY-LIST');
    
    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);
    reqInputMsg.addParam({paraName: 'cpType', paraValue: cpType});
    reqInputMsg.addParam({paraName: 'dataList', paraValue: dataList});

    return await callCmd(reqInputMsg, 'rest')
      .then((res) => {
        if (res.error.code === '0000') {
          if (res.result[0].resultMsg) {
            notification.success({placement: 'bottomLeft', message:`저장이 성공하였습니다.`, duration: 2});
            this.disCompanyList(cpType);
          } else {
            notification.success({placement: 'bottomLeft', message:`저장이 실패하였습니다.`, duration: 2});
          }
        } else if (res.error.code === '0003') {
          if (this._commonStoreInfo !== null) {
            this._commonStoreInfo.onSessionOut();
          }
        } else {
          notification.success({placement: 'bottomLeft', message:`저장이 실패하였습니다.`, duration: 2, description: `${res.error.code}`});
        }
      }).catch((error) => {
        notification.error({placement: 'bottomLeft', message:`저장이 실패하였습니다.`, duration: 2, description: `서버 연결을 확인하세요.`});
        console.log('error', error);
      });
  };

  //-----------------------------------
  //  대시보드 관련
  //-----------------------------------
  @observable
  _dashboardInfo = null;

  @computed
  get dashboardInfo() {
    return this._dashboardInfo;
  }

  @action
  disDashboardInfo = async () => {
    let addition = new Addition();
    addition.setCmdName('DIS-DASHBOARD-INFO');
    
    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);

    return await callCmd(reqInputMsg, 'order')
      .then((res) => {
        if (res.error.code === '0000') {
          // notification.success({placement: 'bottomLeft', message:`조회가 성공하였습니다.`, duration: 2});
          if (res.result.length > 0) {
            this._dashboardInfo = res.result[0];
          } else {
            this._dashboardInfo = null;
          }
          
        } else if (res.error.code === '0003') {
          if (this._commonStoreInfo !== null) {
            this._commonStoreInfo.onSessionOut();
          }
        } else {
          notification.error({placement: 'bottomLeft', message:`불러오는데 실패하였습니다.`, duration: 2, description: `${res.error.code}`});
          this._dashboardInfo = null;
        }
      }).catch((error) => {
        notification.error({placement: 'bottomLeft', message:`조회가 실패하였습니다.`, duration: 2, description: `서버 연결을 확인하세요.`});
        this._dashboardInfo = null;
        console.log('error', error);
      });
  };
}
  
